import { ThunkAction } from 'redux-thunk';
import { Dispatch } from 'redux';
import { RootState } from '../reducer'; // adjust path as needed
import { ApplicationConstants } from './constants';
import { ApplicationAction } from './types'; // adjust path

export const addApplicationKey = (
  key: string,
  value: unknown
): ThunkAction<void, RootState, unknown, ApplicationAction> => {
  return (dispatch: Dispatch<ApplicationAction>) => {
    dispatch({
      type: ApplicationConstants.ADD_APPLICATION_KEY,
      response: {
        [key]: value,
      },
    });
  };
};

export const updateApplicationKey = (
  key: string,
  value: unknown
): ThunkAction<void, RootState, unknown, ApplicationAction> => {
  return (dispatch: Dispatch<ApplicationAction>) => {
    dispatch({
      type: ApplicationConstants.UPDATE_APPLICATION_KEY,
      response: {
        [key]: value,
      },
    });
  };
};
